<template>
  <modal
    v-bind="$attrs"
    v-on="$listeners"
    :title="$t('start_learning.send_sms_link_modal.title')"
  >
    <template v-slot:body>

      <el-form class="create-edit-form" :model="form" :rules="rules" ref="form" @change.native="onFormChange">
        <elsa-select
          popper-class="phone-type"
          name="phoneType"
          :label="$t('start_learning.send_sms_link_modal.phone_type_field.label')"
          :placeholder="$t('start_learning.send_sms_link_modal.phone_type_field.placeholder')"
          :options="phoneTypes"
          v-model.lazy="form.phoneType"
          @change="onFormChange"
        />
        <div class="form-row">
          <div class="phone-wrapper">
            <country-select
              :label="$t('start_learning.send_sms_link_modal.phone_field.label')"
              :placeholder="$t('start_learning.send_sms_link_modal.phone_field.code')"
              v-model="form.phoneCode"
              type="phone"
            />
            <elsa-input
              name="phone"
              type="number"
              :placeholder="$t('start_learning.send_sms_link_modal.phone_field.placeholder')"
              v-model.lazy="form.phoneNumber"
            >
              {{ $t('start_learning.send_sms_link_modal.phone_field.label') }}
            </elsa-input>
          </div>
        </div>
      </el-form>
    </template>
    <template v-slot:footer>
      <primary-button
        @click.native="handleGetSmsLink"
        ref="submit"
        disabled
      >
        {{ $t('start_learning.send_sms_link_modal.get_sms_link') }}
      </primary-button>
    </template>
  </modal>
</template>

<script>
  import Modal from '@/components/common/Modal'
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import ElsaInput from '@/components/common/Input'
  import ElsaSelect from '@/components/common/Select'
  import CountrySelect from '@/components/common/CountrySelect'
  import { handleSubmitButtonState, isPropEmpty } from '@/helpers/formValidationHelper'
  import phoneTypes from '@/constants/phoneTypes'
  import { always, path, split, pathOr, compose, join, pick, values, propOr } from 'ramda'
  import { warningMessage, successMessage } from '../../../utils/messages'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      Modal,
      PrimaryButton,
      ElsaInput,
      ElsaSelect,
      CountrySelect
    },
    data() {
      return {
        form: {},
        rules: {
          email: { type: 'email', message: this.$t('start_learning.send_sms_link_modal.email_validation_msg'), trigger: 'blur' },
          phone: { type: 'number', message: this.$t('start_learning.send_sms_link_modal.phone_field.validation_msg'), trigger: 'blur' }
        }
      }
    },
    methods: {
      onFormChange() {
        const invalid = isPropEmpty('phoneCode')(this.form) ||
                        isPropEmpty('phoneType')(this.form) ||
                        isPropEmpty('phoneNumber')(this.form)
        handleSubmitButtonState(this.$refs.submit.$el, !invalid)
      },
      async handleGetSmsLink() {
        // handleFormValidation(this.$refs.form, () => { this.dialogVisible = true }, () => { this.dialogVisible = true })

        const application = path(['form', 'phoneType'])(this)
        const phone = compose(
          join(' '),
          values,
          pick([ 'phoneCode', 'phoneNumber']),
          propOr({}, 'form'),
        )(this)

        try {
          await this.$axios.post('/v1/invitations/sms', { application, phone })
        } catch {
          return warningMessage(this.$t('start_learning.send_sms_link_modal.warning'))(this)
        }

        this.$emit('closed')
        this.$refs.form.resetFields()
        this.form = {}
        successMessage(this.$t('start_learning.send_sms_link_modal.success'))(this)
      }
    },
    computed: {
      phoneTypes: always(phoneTypes),
      ...mapGetters({
        userInfo: 'user/getUser'
      })
    },
    watch: {
      ['$attrs.dialogVisible'](visible) {
        if(visible) {
          const [phoneCode, phoneNumber] = compose(
            split(' ', ),
            pathOr('', ['userInfo', 'phone_number'])
          )(this)

          this.form = {
            phoneCode,
            phoneNumber,
          }
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  ::v-deep .el-dialog.elsa-modal {
    width: 587px;
    .el-form-item__label {
      text-transform: none;
    }
  }

  form {
    width: 320px;
  }


  ::v-deep .el-form > div {
    padding: 8px 0;
  }

</style>
